function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailed = function SvgFailed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 126 126",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 63,
    style: {
      fill: "#fa6e6e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9 82.9c-.5 0-1-.2-1.4-.6L63.2 66 46.9 82.3c-.8.8-2 .8-2.8 0-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4l16.3-16.3-16.3-16.3c-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4c.8-.8 2-.8 2.8 0l16.3 16.3 16.3-16.3c.8-.8 2-.8 2.8 0 .4.4.6.9.6 1.4s-.2 1-.6 1.4L66 63.2l16.3 16.3c.4.4.6.9.6 1.4s-.2 1-.6 1.4-.9.6-1.4.6",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailed);
export default ForwardRef;